import {useEffect, useState} from "react";

import SwitchView from "@/components/SwitchView";
import VLFModal from "@/components/Modal";
import VLFSelectNew from "@/components/Input/SelectNew";

import {REQUIRED_FIELD} from "@/utils/constants";
import {checkRequiredFields} from "@/utils/functions";

const requiredFields = ["player"];

function HandleAttendanceModal(props) {
	const {open, confirm, close, initialData, internalTeams, players} = props;

	const [formData, setFormData] = useState({});
	const [errors, setErrors] = useState([]);

	const [insertType, setInsertType] = useState("multiple");
	const [categoryType, setCategoryType] = useState(
		initialData?.matchCategoryId,
	);

	const currentInternalTeam = internalTeams?.filter(
		(t) => t.playerCategoryId === initialData?.matchCategoryId,
	)?.[0];
	const categoryPlayers = players?.filter((p) =>
		currentInternalTeam?.players?.find((tp) => tp.playerId === p.id),
	);
	// const categoryPlayers = currentInternalTeam?.players
	// 	?.filter((p) => players?.find((tp) => tp.id === p.playerId))
	// 	?.map((p) => p.player);

	useEffect(() => {
		if (insertType === "multiple" && initialData?.status === "Presente") {
			setFormData({
				...formData,
				player: categoryPlayers?.map((p) => {
					return {
						value: p.id,
						label: p.firstName + " " + p.lastName,
						sortKey: p.lastName,
					};
				}),
			});
		}
	}, [insertType, initialData]);

	useEffect(() => {
		if (!open) {
			setFormData({});
		}
	}, [open]);

	const getPlayerValue = () => {
		return insertType === "multiple"
			? formData?.player?.sort((a, b) => {
					const nameA = a?.sortKey.toLowerCase();
					const nameB = b?.sortKey.toLowerCase();

					if (nameA < nameB) return -1;
					if (nameA > nameB) return 1;
					return 0;
				})
			: formData?.player || "";
	};

	const currentPlayers =
		categoryType === initialData?.matchCategoryId
			? categoryPlayers
			: players?.filter((p) => p.categoryId !== initialData?.matchCategoryId);

	return (
		<VLFModal
			open={open}
			title={"Aggiungi informazione"}
			close={close}
			confirm={() => {
				const errors = checkRequiredFields(requiredFields, formData);
				setErrors(errors);

				if (!errors.length) {
					confirm(formData, initialData?.status, insertType);
				}
			}}
			content={
				<div className="row no-margin">
					<div className="col-12 padding-small">
						<SwitchView
							currentSwitchView={insertType}
							setCurrentSwitchView={(value) => {
								setInsertType(value);

								if (value === "multiple") {
									setCategoryType(initialData?.matchCategoryId);
								}
							}}
							pageOptions={[
								{value: "single", label: "Singolo"},
								{value: "multiple", label: "Multiplo"},
							]}
							fixed
							callback={() => {
								setFormData({
									player: null,
								});
							}}
						/>
						{insertType === "single" && (
							<SwitchView
								currentSwitchView={categoryType}
								setCurrentSwitchView={setCategoryType}
								pageOptions={[
									{
										value: initialData?.matchCategoryId,
										label: initialData?.matchCategoryLabel,
									},
									{value: "others", label: "Altre categorie"},
								]}
								fixed
								callback={() => {
									setFormData({
										player: null,
									});
								}}
							/>
						)}
						<VLFSelectNew
							options={currentPlayers?.map((p) => {
								return {
									value: p.id,
									label: p.firstName + " " + p.lastName,
									sortKey: p.lastName,
								};
							})}
							sortKey="sortKey"
							isMulti={insertType === "multiple"}
							isClearable={insertType === "single"}
							value={getPlayerValue()}
							onChange={(value) => {
								setErrors([]);
								setFormData({...formData, player: value});
							}}
							required
							helperText={errors.indexOf("player") !== -1 ? REQUIRED_FIELD : ""}
							error={errors.indexOf("player") !== -1}
							label="Giocatore"
						/>
					</div>
				</div>
			}
		/>
	);
}

export default HandleAttendanceModal;
